export default {
    language: "Português (Brasil)",
    StripeSuccess: {
        loading: "Processando seu pagamento...",
        successMessage: "Sua assinatura foi ativada com sucesso!",
        processingError: "Falha no processamento do pagamento, entre em contato conosco",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "E-mail",
            createdAt: "Criado em",
            noRecord: "Sem registros",
            loginTime: "Hora de login",
        },
        orders: {
            title: "Histórico de pedidos",
            loading: "Carregando...",
            refresh: "Atualizar",
            orderAmount: "Valor",
            points: "Pontos",
            createdAt: "Criado em",
            orderType: "Tipo",
            status: "Status",
            noOrders: "Sem pedidos",
            goToSubscription: "Comprar pontos",
            freeCredit: "Crédito gratuito",
            paidCredit: "Crédito pago",
            queryOrderFailed: "Falha ao consultar pedido",
            statusPaid: "Pago",
            statusPending: "Pendente",
            statusCancelled: "Cancelado",
            statusDeactivated: "Desativado",
            checkoutUrlNotAvailable: "Falha ao obter URL de pagamento",
            verifyingPayment: "Verificando status do pagamento...",
            paymentSuccess: "Pagamento bem-sucedido",
            paymentPending: "O pedido está pendente de pagamento, por favor complete o pagamento",
            paymentFailed: "Pagamento falhou ou foi cancelado",
            paymentStatus: "Status do pagamento",
            paymentStatusDescription: "Você completou o pagamento?",
            cancelPayment: "Cancelar pagamento",
            completedPayment: "Pagamento concluído",
            warning: "Aviso",
            confirmCancelOrder: "Tem certeza que deseja cancelar este pedido? Esta ação não pode ser desfeita.",
            cancel: "Cancelar",
            confirm: "Confirmar",
            cancellingOrder: "Cancelando pedido...",
            orderCancelledSuccess: "Pedido cancelado",
            cancelOrderFailed: "Falha ao cancelar pedido",
            checkOrderStatusFailed: "Falha ao verificar status do pedido",
            promptClick: "Clique no status \"Pendente\" para continuar o pagamento",
        }
    },
    UserFeedback: {
        title: "Avaliações de Usuários",
        feedback: "Ouça avaliações reais de criadores e profissionais de todo o mundo sobre nossa tecnologia de processamento de imagens com IA.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Sr. Lin",
                profession: "Editor de vídeo e criador de conteúdo",
                rating: 5,
                comment: "Incrível! O ClixMagicAI é super rápido! Faça upload de um vídeo com marca d'água e em minutos você terá uma versão sem marca d'água, sem perda de qualidade. Uma ferramenta essencial para remoção de marcas d'água!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Sra. Su",
                profession: "Especialista em mídias sociais",
                rating: 5,
                comment: "O ClixMagicAI salvou minha biblioteca de conteúdo do Instagram! Identifica com precisão marcas d'água complexas, o processamento de bordas é muito mais refinado que outros softwares e o resultado final parece mais natural."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Sr. Chen",
                profession: "Produtor de conteúdo para vídeos curtos",
                rating: 5,
                comment: "A remoção de marcas d'água com o ClixMagicAI é super conveniente. Processo material do TikTok durante o trajeto para o trabalho e baixo a versão em HD assim que chego ao escritório. Duplica a eficiência! Uma bênção para profissionais de mídia."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Sr. Huang",
                profession: "Designer gráfico e diretor criativo visual",
                rating: 5,
                comment: "Como designer, estou muito satisfeito! Ao processar imagens de amostra com logotipos fornecidas pelos clientes, a textura de fundo é restaurada naturalmente, sem rastros de Photoshop, economizando muito tempo de pós-processamento."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Sra. Emily",
                profession: "Criadora de conteúdo digital freelancer",
                rating: 5,
                comment: "Encontrei um tesouro! O preço da assinatura é muito mais barato que outros produtos de remoção de marca d'água no mercado, mas o efeito é ainda melhor, especialmente ao processar marcas d'água transparentes com gradiente."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Sr. Robertson",
                profession: "Desenvolvedor de cursos de treinamento corporativo",
                rating: 5,
                comment: "O ClixMagicAI é muito conveniente por não precisar de instalação! Meu computador da empresa tem restrições de permissão para instalar software, agora posso processar material de curso apenas com o navegador, a qualquer hora e em qualquer lugar."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Sra. Zhou",
                profession: "Dona de casa e editora de conteúdo comunitário",
                rating: 5,
                comment: "A interface é tão simples que até minha avó conseguiria usar! Se você não tem tempo para aprender softwares profissionais como Photoshop, experimente o ClixMagicAI. Perfeito para usuários iniciantes como eu. Haha~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Sr. Johnson",
                profession: "Estrategista visual de e-commerce",
                rating: 5,
                comment: "O ClixMagicAI é super poderoso, pode remover imagens, vídeos, pequenos objetos, pessoas, texto e muito mais. Funcionalidades completas, recomendo a todos~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Sra. Fang",
                profession: "Entusiasta de fotografia e compartilhadora de conteúdo online",
                rating: 5,
                comment: "Uau~ Finalmente encontrei uma ferramenta de remoção de marca d'água que não degrada a qualidade da imagem! Mágico como um feitiço~ Editar fotos não é mais um problema! Recomendo fortemente!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Sr. Williams",
                profession: "Instrutor de educação online",
                rating: 5,
                comment: "O recurso de memória de posição da marca d'água é super útil! Ao processar vídeos de séries de cursos, não preciso selecionar repetidamente, economiza pelo menos meia hora de trabalho e aumenta significativamente minha eficiência na preparação de aulas."
            }
        ]
    },
    Order: {
        purchasePoints: "Comprar Pontos",
        subtitle: "Escolha um pacote de pontos adequado para desfrutar do serviço de remoção de marca d\"água",
        loginReminderDesc: "Faça login para selecionar e comprar pontos",
        freeTag: "Grátis",
        freePlan: "Plano Gratuito",
        autoActivated: "Ativado automaticamente após login",
        points: "Pontos",
        autoIncluded: "Presente grátis",
        discount: "Desconto",
        purchase: "Comprar Agora",
        paymentStatusDescription: "Você completou o pagamento?",
        paymentNotCompleted: "Pagamento não concluído",
        queryOrderFailed: "Falha ao verificar status do pedido",
        cancelPayment: "Cancelar Pagamento",
        completedPayment: "Pagamento Concluído",
        warning: "Aviso",
        confirmCancelOrder: "Tem certeza que deseja cancelar este pedido? Esta ação não pode ser desfeita.",
        cancel: "Cancelar",
        confirm: "Confirmar",
        selectProductFirst: "Selecione um pacote primeiro",
        creatingOrder: "Criando pedido...",
        orderCreated: "Pedido criado com sucesso",
        createOrderFailed: "Falha ao criar pedido",
        checkoutUrlNotAvailable: "Falha ao obter link de pagamento",
        cancellingOrder: "Cancelando pedido...",
        orderCancelledSuccess: "Pedido cancelado",
        cancelOrderFailed: "Falha ao cancelar pedido",
        verifyingPayment: "Verificando status do pagamento...",
        paymentSuccess: "Pagamento bem-sucedido",
        paymentPending: "Pedido aguardando pagamento, por favor conclua o pagamento",
        paymentFailed: "Pagamento falhou ou foi cancelado",
        checkOrderStatusFailed: "Falha ao verificar status do pedido",
        quickStart: "Início Rápido",
        shortTerm: "Uso de Curto Prazo",
        recommended: "Recomendado",
        bestValue: "Melhor Valor",
    },
    Login: {
        title: "Login",
        subtitle: "Login rápido com contas sociais",
        memberTip: "Faça login para aproveitar mais recursos",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Login com GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Login com Google"
            }
        ],
        error: {
            serverError: "Erro no servidor, tente novamente mais tarde",
            networkError: "Erro de rede, verifique sua conexão"
        }
    },
    OAuthCallback: {
        loading: "Processando solicitação de login",
        pleaseWait: "Aguarde, verificando informações de login...",
        error: "Falha no login",
        backToHome: "Voltar para a Página Inicial",
        success: "Login bem-sucedido",
        redirecting: "Redirecionando para a página inicial..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Preços",
            faq: "Perguntas frequentes",
        },
        login: "Login",
        userMenu: {
            account: "Conta",
            logout: "Sair",
            credit: "Pontos",
            freeCredit: "Grátis",
            paidCredit: "Comprados",
            nextUpdate: "Próxima atualização de pontos",
            language: "Idioma",
            theme: "Tema",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "Funcionalidades do ClixMagicAI",
        advs: [
            {
                title: "Motor de Reconhecimento por IA: Detecção Automática de Elementos Intrusivos",
                desc: "Baseado em algoritmos de aprendizado profundo, identifica automaticamente marcas d\"água, texto, rostos e elementos complexos em imagens/vídeos, sem necessidade de marcação manual. Suporta formatos do Instagram, TikTok e outras plataformas, com proteção rigorosa de dados privados.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Remover Marca d'água"
            },
            {
                title: "Mestre em Limpeza de Imagens: Remove Logos/Carimbos de Data Rapidamente, Mantendo a Qualidade",
                desc: "Remove com precisão marcas d\"água de marcas, datas de captura, adesivos e outros elementos indesejados. A IA restaura automaticamente a textura do fundo, as imagens processadas parecem naturais como o original, perfeitas para publicações em redes sociais.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Remover Marca d'água"
            },
            {
                title: "Removedor de Marcas d'água Dinâmicas: Apaga Legendas Rolantes/Logos de Plataformas",
                desc: "Remova com um clique cartões finais do YouTube, marcas d\"água do TikTok e textos rolantes. A IA rastreia e processa cada quadro, produzindo vídeos 4K de alta qualidade fluidos, suporta formatos MP4/MOV e outros formatos populares.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Remover Marca d'água"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Uma ferramenta profissional com IA para remover marcas d\"água de imagens, vídeos e PDFs rapidamente e com facilidade, fornecendo resultados naturais.",
        fileTypes: {
            image: "Remover Marca d\"água de Imagem",
            pdf: "Remover Marca d\"água de PDF",
            video: "Remover Marca d\"água de Vídeo"
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Teste Grátis Diário", icon: "fa-gift" },
            { id: "imageTag", text: "Remoção de Marca d\"água de Imagem", icon: "fa-image" },
            { id: "videoTag", text: "Remoção de Marca d\"água de Vídeo", icon: "fa-video" },
            { id: "aiPoweredTag", text: "Com IA", icon: "fa-robot" },
            { id: "noRegTag", text: "Login e Uso", icon: "fa-user-check" },
        ],
        videoPromt: "Em breve!",
        videoDesc: "Estamos desenvolvendo o recurso de remoção de marca d\"água de vídeo para oferecer uma experiência ainda melhor."
    },
    Footer: {
        social: {
            title: "Contate-nos",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "Termos Legais",
        terms: [
            {
                id: 1,
                title: "Política de Privacidade",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Termos de Serviço",
                link: "/terms"
            },
            {
                id: 3,
                title: "Política de Cookies",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI Todos os direitos reservados."
    },
    Task: {
        image: {
            imageSupportText: "Suporta formatos jpg, jpeg, png, webp, heic, heif, máximo 10MB por arquivo",
            imageFileTooLarge: "Tamanho do arquivo excede o limite (máx 10MB)",
            invalidImageType: "Formato de imagem não suportado, envie JPG, JPEG, PNG, WEBP, HEIC ou HEIF",
            imageWillCost: "Custará: 1 ponto",
            hiecSupportText: "Formatos HEIC/HEIF serão convertidos automaticamente para PNG ao enviar",
            hiecSuccess: "Formato HEIC/HEIF convertido com sucesso",
            hiecFailed: "Falha na conversão do formato HEIC/HEIF",
            processingImageTip: "Processando sua imagem, aguarde...",
            guide: {
                title: "Guia de Uso",
                step1: "Envie uma imagem",
                step2: "Pinte a área da marca d\"água ou deixe o modelo detectar automaticamente",
                step3: "Clique em enviar"
            }
        },
        common: {
            remaining: "Pontos restantes",
            nextUpdate: "Próxima atualização de pontos",
            handleError: "Erro ao processar arquivo, tente outro arquivo",
            uploadFailed: "Falha no upload do arquivo",
            dragText: "Arraste arquivos aqui ou",
            clickText: "clique para upload",
            loginRequired: "Faça login antes de enviar arquivos",
            noRemainingTasks: "Seus pontos acabaram",
            loginNow: "Login Agora",
            upgradeNow: "Comprar Pontos Agora",
            taskSubmitSuccess: "Tarefa enviada com sucesso",
            taskSubmitError: "Falha ao enviar tarefa",
            taskRetrySuccess: "Retry da tarefa enviado com sucesso!",
            taskRetryError: "Falha ao enviar retry da tarefa!",
            processing: "Processando",
            submit: "Enviar",
            waiting: "Aguardando",
            completed: "Concluído",
            failed: "Falhou",
            cancelled: "Cancelado",
            url_not_found: "Falha ao obter link",
            deleted: "Excluído",
            refreshSuccess: "Lista de tarefas atualizada",
            refreshFailed: "Falha ao atualizar lista de tarefas",
            deleteSuccess: "Tarefa excluída com sucesso",
            deleteFailed: "Falha ao excluir tarefa",
            waitingForCompletion: "Aguarde a conclusão da tarefa atual antes de tentar novamente",
            loadOriginalImageFailed: "Falha ao carregar imagem original, tente novamente",
            downloadFailed: "Download falhou",
            startingDownload: "Iniciando download...",
            noTasks: "Sem tarefas",
            refresh: "Atualizar",
            sort: "Ordenar",
            noFilterTasks: "Sem tarefas {filter}",
            compare: "Ver comparação",
            originalImage: "Imagem original",
            processedImage: "Imagem processada",
            dragToCompare: "👈 Arraste para comparar 👉",
            cancel: "Cancelar",
            delete: "Excluir",
            retry: "Tentar novamente",
            download: "Download",
            createAt: "Criado em",
            expiredAt: "Expira em",
        },
        video: {
            videoSupportText: "Suporta formatos mp4, mov, avi, mkv, máximo 100MB por arquivo",
            videoFileTooLarge: "Tamanho do arquivo excede o limite (máx 100MB)",
            invalidVideoType: "Formato de vídeo não suportado, envie MP4, MOV, AVI ou MKV",
            videoWillCost: "Custará: 3 pontos",
            processingVideoTip: "Processando seu vídeo, aguarde...",
            guide: {
                step1: "Envie um vídeo",
                step2: "Selecione o tipo de marca d\"água e defina a área",
                step3: "Clique em enviar"
            },
            annotationTools: "Ferramentas de Anotação",
            selectType: "Selecione o Tipo",
            deleteAnnotation: "Excluir Anotação",
            clearAllAnnotations: "Limpar Todas",
            annotationHelp: "Ajuda",
            dragTip: "Arraste para desenhar área",
            resizeTip: "Redimensione para ajustar",
            moveTip: "Anotações podem ser movidas",
            processing: "Processando",
            submit: "Enviar",
            taskSubmitSuccess: "Tarefa enviada com sucesso",
            taskSubmitError: "Falha ao enviar tarefa",
            retryTaskTip: "Retry enviado com sucesso",
            retryFailed: "Retry falhou",
            uploadFailed: "Upload falhou",
            staticWatermarkDesc: "Para marcas d\"água estáticas em posição fixa",
            normalWatermarkDesc: "Para marcas d\"água fixas normais",
            dynamicWatermarkDesc: "Para marcas d\"água dinâmicas que variam",
            moveWatermarkDesc: "Para marcas d\"água que precisam ser movidas"
        },
    },
    Router: {
        home: "Início",
        terms: "Termos de Serviço",
        privacy: "Política de Privacidade",
        cookie: "Política de Cookies",
        user: "Central do Usuário",
    },
    FAQ: {
        title: "Guia de Uso e Perguntas Frequentes do ClixMagicAI",
        prompt: "Está com algum problema ou dúvida? Entre em contato conosco a qualquer momento: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "O que é o ClixMagicAI e como ele funciona?",
                answer: "ClixMagicAI é uma ferramenta avançada de remoção de marca d'água com tecnologia de IA. Ela suporta reconhecimento automático de marcas d'água em imagens e vídeos, e oferece a função de marcação manual de posições de marca d'água. Para imagens, suporta vários formatos de conversão e garante saída de alta qualidade; para vídeos, pode processar marcas d'água estáticas, dinâmicas e até mesmo as que mudam de forma."
            },
            {
                id : 2,
                question: "O ClixMagicAI oferece uso gratuito?",
                answer: "Sim, oferecemos um serviço gratuito básico de 3 pontos diários! Você pode usá-los para processar imagens (consumindo 1 ponto por operação) ou vídeos (consumindo 3 pontos por operação). Além disso, você pode comprar pontos adicionais, que são válidos permanentemente."
            },
            {
                id : 3,
                question: "Posso comprar pontos adicionais?",
                answer: "Certamente! Além dos 3 pontos gratuitos concedidos diariamente, você pode adquirir pontos adicionais através de nossas opções de compra. Os pontos comprados serão válidos permanentemente, sem data de expiração."
            },
            {
                id : 4,
                question: "Quais formatos de arquivo são suportados?",
                answer: "Para imagens, suportamos formatos PNG, JPEG, JPG, WEBP, HEIC e HEIF, com HEIC e HEIF sendo automaticamente convertidos para PNG. Para vídeos, suportamos vários formatos, incluindo MP4 e MOV."
            },
            {
                id : 5,
                question: "Como minha privacidade é protegida?",
                answer: "No ClixMagicAI, valorizamos muito a privacidade do usuário. Todos os arquivos enviados são processados com criptografia e automaticamente excluídos dentro de 24 horas após o processamento. Não armazenamos nenhum arquivo do usuário ou informações relacionadas."
            },
            {
                id : 6,
                question: "Como posso fazer login no ClixMagicAI?",
                answer: "Suportamos login rápido via contas GitHub ou Google, garantindo a segurança da sua conta enquanto simplificamos o processo de registro."
            },
            {
                id : 7,
                question: "Qual é a velocidade de processamento?",
                answer: "Graças aos nossos servidores de alto desempenho e algoritmos de IA otimizados, a maioria das tarefas de remoção de marca d'água de imagens pode ser concluída em 10 segundos, enquanto a remoção de marca d'água de vídeo pode levar apenas 1 minuto no mínimo. O tempo real pode variar dependendo do tamanho e complexidade do arquivo."
            },
            {
                id : 8,
                question: "Como é o resultado após o processamento?",
                answer: "Nossos modelos de IA são extensivamente treinados para remover inteligentemente marcas d'água de imagens e vídeos, mantendo a qualidade do conteúdo original. Seja reconhecida automaticamente ou marcada manualmente, a marca d'água é efetivamente removida, garantindo resultados finais naturais e sem vestígios."
            },
            {
                id : 9,
                question: "Qual é o período de validade de cada tarefa?",
                answer: "Uma vez concluída a tarefa, os arquivos processados serão mantidos no ClixMagicAI por 24 horas para download. Após expirar, os arquivos serão automaticamente excluídos de nossos servidores para proteger sua privacidade."
            },
            {
                id : 10,
                question: "Qual é o limite máximo de tamanho de arquivo?",
                answer: "Aceitamos arquivos de imagem com tamanho máximo de 10MB e arquivos de vídeo com tamanho máximo de 100MB. Arquivos que excedam esses limites podem precisar ser comprimidos ou cortados antes do upload."
            }
        ]
    },
    Terms: {
        "tabs": {
            "terms": "Termos de Serviço",
            "privacy": "Política de Privacidade",
            "cookies": "Política de Cookies"
        },
        "lastUpdated": "Última atualização: 20 de maio de 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Introdução",
                    "description": "Bem-vindo ao ClixMagicAI. O uso de nossos serviços implica na aceitação destes termos de serviço. Por favor, leia-os cuidadosamente."
                },
                {
                    "title": "2. Descrição do Serviço",
                    "description": "O ClixMagicAI fornece ferramentas baseadas em IA para remover marcas d'água de imagens, vídeos e arquivos PDF. Nossos serviços são destinados aos seguintes usos legítimos:",
                    "items": [
                        "Remoção de marcas d'água de seu próprio conteúdo",
                        "Remoção de marcas d'água de conteúdo para o qual você possui direitos apropriados de modificação",
                        "Para fins educacionais e de pesquisa"
                    ]
                },
                {
                    "title": "3. Responsabilidades do Usuário",
                    "description": "Ao usar o ClixMagicAI, você concorda em:",
                    "items": [
                        "Fazer upload apenas de conteúdo que você possui ou tem direitos apropriados para modificar",
                        "Não usar nossos serviços para qualquer finalidade ilegal ou que viole qualquer lei",
                        "Não tentar contornar nossas medidas de segurança ou restrições de uso",
                        "Não usar nossos serviços para violar os direitos de propriedade intelectual de terceiros"
                    ]
                },
                {
                    "title": "4. Termos da Conta",
                    "description": "Você pode precisar criar uma conta para usar alguns recursos de nossos serviços. Para fazer login, você pode optar por usar uma conta do Google ou GitHub. Você é responsável por:",
                    "items": [
                        "Manter a segurança da sua conta",
                        "Todas as atividades que ocorrem sob sua conta",
                        "Fornecer informações precisas da conta (incluindo, mas não se limitando a avatar, e-mail, nome de usuário e ID de usuário)"
                    ]
                },
                {
                    "title": "5. Serviços Gratuitos e Pagos",
                    "description": "O ClixMagicAI oferece uma cota básica gratuita e opções flexíveis de compra de pontos para acessar nossos recursos de remoção de marca d'água:",
                    "items": [
                        "Cota básica: Cada usuário receberá automaticamente 3 pontos gratuitos diariamente, que podem ser usados para processamento de conteúdo",
                        "Regras de consumo de pontos: A remoção de marca d'água de imagens consome 1 ponto por operação, a remoção de marca d'água de vídeo consome 3 pontos por operação",
                        "Compra de pontos: Você pode optar por comprar pacotes de pontos para mais uso, todos os pontos comprados são válidos permanentemente, sem restrições de expiração",
                        "Política de reembolso: Devido à natureza instantânea e virtual dos serviços digitais, os pontos não podem ser reembolsados uma vez comprados com sucesso"
                    ]
                },
                {
                    "title": "6. Direitos de Propriedade Intelectual",
                    "description": "O serviço ClixMagicAI, incluindo todo o software, designs e conteúdo que criamos, é nossa propriedade intelectual. Você não pode copiar, modificar ou criar trabalhos derivados baseados em nossos serviços sem permissão."
                },
                {
                    "title": "7. Limitação de Responsabilidade",
                    "description": "O ClixMagicAI fornece o serviço \"como está\", sem garantias de qualquer tipo. Não somos responsáveis por quaisquer danos resultantes do uso de nossos serviços."
                },
                {
                    "title": "8. Alterações nos Termos",
                    "description": "Podemos modificar estes termos a qualquer momento. O uso contínuo do ClixMagicAI após alterações nos termos significa que você aceita os termos modificados."
                },
                {
                    "title": "9. Rescisão",
                    "description": "Reservamo-nos o direito de encerrar ou suspender seu acesso aos nossos serviços imediatamente, sem aviso prévio, se acreditarmos que seu comportamento viola estes termos ou prejudica outros usuários, nós mesmos ou terceiros."
                },
                {
                    "title": "10. Lei Aplicável",
                    "description": "Estes termos serão regidos pelas leis aplicáveis no local de registro de nossa empresa, independentemente das disposições sobre conflitos de leis."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Introdução",
                    "description": "No ClixMagicAI, valorizamos sua privacidade e estamos comprometidos em proteger seus dados pessoais. Esta Política de Privacidade explica como coletamos, usamos e protegemos suas informações quando você usa nosso site e serviços. Ao acessar nosso site ou usar qualquer um de nossos serviços, você aceita as práticas de processamento de dados descritas nesta política. Aderimos aos regulamentos de proteção de dados aplicáveis."
                },
                {
                    "title": "2. Informações que Coletamos",
                    "description": "Podemos coletar os seguintes tipos de informações:",
                    "items": [
                        { "bold": "Informações da conta", "text": "Avatar do usuário, endereço de e-mail, nome de usuário e ID de usuário fornecidos ao fazer login via Google ou GitHub" },
                        { "bold": "Dados de uso", "text": "Informações sobre como você usa nossos serviços, incluindo recursos acessados e tempo de uso" },
                        { "bold": "Conteúdo enviado", "text": "Imagens, vídeos ou arquivos PDF que você envia para processamento" },
                        { "bold": "Informações de pagamento", "text": "Informações de pagamento ao comprar assinaturas (processadas com segurança por gateways de pagamento de terceiros como Creem/Stripe/PayPal, mantemos apenas registros de status de pagamento)" },
                        { "bold": "Dados técnicos", "text": "Endereço IP, tipo de navegador, informações do dispositivo" }
                    ]
                },
                {
                    "title": "3. Como Usamos Suas Informações",
                    "description": "Usamos suas informações para:",
                    "items": [
                        { "text": "Fornecer, manter e melhorar nossos serviços" },
                        { "text": "Processar e completar transações" },
                        { "text": "Enviar notificações técnicas e mensagens de suporte" },
                        { "text": "Responder aos seus comentários e perguntas" },
                        { "text": "Analisar padrões de uso para melhorar a experiência do usuário, e processar dados pessoais apenas na extensão necessária para atingir os propósitos do serviço" },
                        { "text": "Garantir que o período de armazenamento de dados pessoais não exceda o tempo necessário" },
                        { "text": "Prevenir fraudes ou atividades ilegais" }
                    ]
                },
                {
                    "title": "4. Segurança de Dados",
                    "description": "Implementamos medidas de segurança em conformidade com os padrões da indústria para proteger suas informações pessoais:",
                    "items": [
                        { "text": "Criptografia AES-256 para arquivos durante transmissão e armazenamento" },
                        { "text": "Processamento de dados sensíveis usando arquitetura de conhecimento zero" },
                        { "text": "Auditorias diárias de logs de segurança e verificações de vulnerabilidade" },
                        { "text": "O acesso dos funcionários segue o princípio de privilégio mínimo" }
                    ]
                },
                {
                    "title": "5. Compartilhamento de Dados",
                    "description": "Não vendemos suas informações pessoais. Podemos compartilhar informações com:",
                    "items": [
                        { "bold": "Provedores de serviços", "text": "Limitado ao processamento de dados necessário para fornecer serviços específicos (como armazenamento em nuvem CloundFlare, gateways de pagamento de terceiros como Creem/Stripe/PayPal), que devem assinar acordos de processamento de dados" },
                        { "bold": "Requisitos legais", "text": "Quando recebemos uma intimação válida, ordem judicial ou outro processo legal aplicável a nós" }
                    ]
                },
                {
                    "title": "6. Seus Direitos",
                    "description": "De acordo com as leis aplicáveis em sua região, você pode ter os seguintes direitos:",
                    "items": [
                        { "text": "Acessar uma cópia de seus dados pessoais" },
                        { "text": "Retificar informações incorretas ou incompletas" },
                        { "text": "Direito ao apagamento de dados ('direito ao esquecimento'), a menos que tenhamos uma razão legal para retê-los" },
                        { "text": "Opor-se ou restringir certos tipos de processamento de dados" },
                        { "text": "Direito à portabilidade de dados, você pode solicitar a transferência de seus dados" }
                    ]
                },
                {
                    "title": "7. Privacidade das Crianças",
                    "description": "Nossos serviços não são direcionados a menores de 16 anos. De acordo com o Artigo 8 do Regulamento Geral de Proteção de Dados (GDPR), o consentimento para crianças menores de 16 anos deve ser fornecido por um pai ou responsável. Se você souber que um menor de 16 anos nos forneceu informações pessoais, entre em contato conosco imediatamente em support@clixmagic.com."
                },
                {
                    "title": "8. Alterações nesta Política",
                    "description": "Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre quaisquer alterações significativas publicando a nova política nesta página e atualizando a data de \"última atualização\". Para alterações importantes, notificaremos os usuários por e-mail ou de outra forma proeminente."
                },
                {
                    "title": "9. Contato",
                    "description": "Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco em support@clixmagic.com. Se você acredita que seus dados foram processados de maneira inadequada ou tem alguma preocupação, não hesite em nos contatar a qualquer momento."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. O que são Cookies",
                    "description": "Cookies são pequenos arquivos de texto colocados em seu computador ou dispositivo móvel quando você visita um site. Eles permitem que os sites reconheçam seu dispositivo e lembrem se você visitou o site anteriormente."
                },
                {
                    "title": "2. Como Usamos Cookies",
                    "description": "O ClixMagicAI usa cookies para vários propósitos:",
                    "items": [
                        { "bold": "Cookies necessários", "text": "Necessários para a funcionalidade básica do nosso site (como gerenciamento de sessão e recursos de segurança)" },
                        { "bold": "Cookies de preferências", "text": "Lembram suas configurações e preferências para melhorar sua experiência, por exemplo, lembrando seu avatar, nome de usuário, etc. depois de fazer login via Google ou GitHub" },
                        { "bold": "Cookies analíticos", "text": "Nos ajudam a entender como os visitantes interagem com nosso site coletando informações anônimas" },
                        { "bold": "Cookies de marketing", "text": "Rastreiam seus hábitos de navegação para oferecer publicidade relevante aos seus interesses" }
                    ]
                },
                {
                    "title": "3. Tipos de Cookies que Usamos",
                    "subsection": [
                        {
                            "title": "3.1 Cookies Necessários",
                            "description": "Esses cookies são essenciais para o funcionamento adequado do site. Eles permitem funções centrais como segurança, gerenciamento de rede e acesso à conta (incluindo login via Google e GitHub). Você pode configurar seu navegador para bloquear esses cookies, mas algumas partes do site podem não funcionar corretamente."
                        },
                        {
                            "title": "3.2 Cookies de Desempenho e Análise",
                            "description": "Esses cookies nos ajudam a entender como os visitantes interagem com nosso site coletando informações anônimas. Usamos esses dados para melhorar nosso site e serviços. Esses cookies não coletam informações que possam identificar um visitante."
                        },
                        {
                            "title": "3.3 Cookies de Funcionalidade",
                            "description": "Esses cookies permitem que nosso site lembre das escolhas que você faz (como preferências de idioma ou estado de login) para fornecer funcionalidades personalizadas aprimoradas, como lembrar seu estado de login via Google ou GitHub."
                        },
                        {
                            "title": "3.4 Cookies de Direcionamento e Publicidade",
                            "description": "Esses cookies são usados para exibir publicidade relevante aos visitantes e rastrear a eficácia de nossas campanhas publicitárias. Observe que, como nosso site depende principalmente de login de terceiros (Google e GitHub), esse tipo de cookie é usado principalmente para melhorar a experiência do usuário e não para marketing direto."
                        }
                    ]
                },
                {
                    "title": "4. Gerenciamento de Cookies",
                    "description": "Você pode controlar e gerenciar cookies de várias maneiras. A maioria dos navegadores da web permite gerenciar preferências de cookies. Você pode:",
                    "items": [
                        { "text": "Excluir cookies do seu dispositivo" },
                        { "text": "Bloquear cookies ativando configurações do seu navegador que permitem recusar alguns ou todos os cookies" },
                        { "text": "Configurar seu navegador para alertá-lo quando receber cookies" }
                    ]
                },
                {
                    "title": "5. Cookies de Terceiros",
                    "description": "Alguns cookies são colocados por terceiros em nosso site. Esses terceiros podem incluir serviços de análise (como Google Analytics) e redes de publicidade. Devido à forma como os cookies funcionam (cookies só podem ser acessados pela parte que originalmente os definiu), não controlamos o uso desses cookies de terceiros e não podemos acessá-los. Para usuários que fazem login via Google e GitHub, garantiremos que as diretrizes de privacidade dessas plataformas sejam seguidas ao lidar com informações relacionadas."
                },
                {
                    "title": "6. Atualizando esta Política de Cookies",
                    "description": "Podemos atualizar esta Política de Cookies de tempos em tempos para refletir mudanças na tecnologia, regulamentos ou nossas práticas comerciais. Quaisquer alterações serão publicadas nesta página e a data da revisão será atualizada."
                },
                {
                    "title": "7. Contato",
                    "description": "Se você tiver alguma dúvida sobre nosso uso de cookies, entre em contato conosco em support@clixmagic.com."
                }
            ]
        }
    },
}